export const getEuTyreLink = (market: string, language: string) => {
	switch (market) {
		case 'be':
			switch (language) {
				case 'fr':
					return 'https://www.fr.audi.be/be/web/fr/modeles/label-pneumatique-eu.html';
				case 'nl':
					return 'https://www.nl.audi.be/be/web/nl/modellen/eu-bandenlabel.html';

				default:
					return 'https://www.fr.audi.be/be/web/fr/modeles/label-pneumatique-eu.html';
			}

		case 'ch':
			switch (language) {
				case 'fr':
					return 'https://www.audi.ch/ch/web/fr/neuwagen/etiquette-ue.html';
				case 'de':
					return 'https://www.audi.ch/ch/web/de/neuwagen/eu-reifenlabel.html';

				case 'it':
					return 'https://www.audi.ch/ch/web/it/neuwagen/etichetta-europea.html';

				default:
					return 'https://www.audi.ch/ch/web/fr/neuwagen/etiquette-ue.html';
			}

		case 'de':
			return 'https://www.audi.de/de/brand/de/neuwagen/eu-reifenlabel.html';

		case 'dk':
			return 'https://www.audi.dk/dk/web/da/modeller/eu-daekmaerkat.html';
		case 'es':
			return 'https://www.audi.es/es/web/es/modelos/etiquetado-neumaticos-eu.html';

		case 'fi':
			return 'https://www.audi.fi/fi/web/fi/models/eu-rengasmerkinnat.html ';
		case 'fr':
			return 'https://www.audi.fr/fr/web/fr/gamme/etiquettes-energetiques-pneumatiques.html';

		case 'gr':
			return 'https://www.audi.gr/gr/web/el/models/eu-tyre-label.html';
		case 'it':
			return 'https://www.audi.it/it/web/it/etichettatura-europea-pneumatici.html ';

		case 'ie':
			return 'https://www.audi.ie/ie/web/en/models/eu-tyre-label.html';

		case 'lu':
			switch (language) {
				case 'fr':
					return 'https://www.audi.lu/lu/web/fr/gamme/etiquettes-energetiques-pneumatiques.html';
				case 'de':
					return 'https://www.audi.lu/lu/web/de/neuwagen/eu-reifenlabel.html';

				default:
					return 'https://www.audi.lu/lu/web/fr/gamme/etiquettes-energetiques-pneumatiques.html';
			}
		case 'nl':
			return 'https://www.audi.nl/nl/web/nl/modellen/eu-banden-label.html';
		case 'pl':
			return 'https://www.audi.pl/pl/web/pl/modele/etykieta-opon.html';

		case 'se':
			return 'https://www.audi.se/se/web/sv/models/eu-dackmarkning.html';
		case 'gb':
			return 'https://www.audi.co.uk/uk/web/en/models/eu-tyre-label.html';
		case 'tr':
			return 'https://www.audi.com.tr/tr/web/tr/modeller/eu-tyre-label.html';

		default:
			return '';
	}
};
